import { render } from "./CategoryVideos.vue?vue&type=template&id=0601d49c&scoped=true"
import script from "./CategoryVideos.vue?vue&type=script&lang=js"
export * from "./CategoryVideos.vue?vue&type=script&lang=js"

import "./CategoryVideos.vue?vue&type=style&index=0&id=0601d49c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0601d49c"]])

export default __exports__